// extracted by mini-css-extract-plugin
export default {"Newsletter":"style_Newsletter__U6R0c","left":"style_left__OM+li","right":"style_right__nrD15","form":"style_form__HHCwc","textBackground":"style_textBackground__5f1a0"};